<template>
  <Menu :closeOnContentClick="false" :options="executionOptions">
    <template v-slot:activator="{ on }">
      <Button icon="mdi-dots-vertical" color="blueGrey" v-on="on" />
    </template>
  </Menu>
</template>
<script>
import Button from '@/components/UI/Button'
import Menu from '@/components/UI/Menu.vue'
import _ from 'lodash'

export default {
  name: 'ExecutionMenu',

  components: {
    Button,
    Menu,
  },

  computed: {
    executionOptions() {
      return _.compact([
        {
          title: this.$t('history.history'),
          id: 0,
          icon: 'mdi-clock-outline',
          action: () => this.$emit('showHistory'),
        },
        this.canDelete && {
          title: this.$t('common.button.delete'),
          id: 1,
          icon: 'mdi-delete-outline',
          action: () => this.$emit('delete'),
        },
      ])
    },
  },

  props: {
    canDelete: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
